/** Настройки игрока: звук, вибрация, подсветка, язык. */

import { type Language, normalizeLanguage, setLanguage } from '../i18n'
import { readSetting, writeSetting } from '../telegram/storage'

export interface Settings {
  sound: boolean
  haptics: boolean
  /** Подсветка клеток с той же цифрой. Кому-то она мешает считать. */
  highlightSame: boolean
  language: Language
}

const KEY = 'sudoku.settings'

export const DEFAULT_SETTINGS: Settings = {
  sound: true,
  haptics: true,
  highlightSame: true,
  language: 'ru',
}

let current: Settings = { ...DEFAULT_SETTINGS }

export function getSettings(): Settings {
  return current
}

function apply(settings: Settings): void {
  current = settings
  setLanguage(settings.language)
}

/**
 * Загрузить настройки, взяв язык из профиля Telegram как значение по
 * умолчанию: игрок с английским интерфейсом мессенджера не должен видеть
 * русский, пока не залезет в настройки.
 */
export async function loadSettings(profileLanguage?: string): Promise<Settings> {
  const fallback: Settings = {
    ...DEFAULT_SETTINGS,
    language: normalizeLanguage(profileLanguage),
  }

  try {
    const raw = await readSetting(KEY)
    const stored = raw ? (JSON.parse(raw) as Partial<Settings>) : {}
    apply({ ...fallback, ...stored })
  } catch {
    // Битое значение или недоступное хранилище — не повод остаться без
    // настроек и тем более не повод не запустить игру.
    apply(fallback)
  }
  return current
}

export function updateSettings(patch: Partial<Settings>): Settings {
  apply({ ...current, ...patch })
  writeSetting(KEY, JSON.stringify(current))
  return current
}
